import styled from "styled-components";
import global from "../../global";

type FixcoinItem = {
    isSelected: boolean;
    isPopular?: boolean;
}

export const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    gap: 20px 16px;
    margin-top: 12px;

    @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
        gap: 20px 8px;
    }
`

export const FixcoinValue = styled.div<{ isSelected?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    font-size: 22px;
    font-weight: 800;
    color: ${({ isSelected }) => isSelected ? "var(--white)" : "var(--dark-gray)"};
    transition: color 0.2s ease-in-out;

    @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
        font-size: 18px;
    }
`

export const FixcoinItem = styled.div<FixcoinItem>`
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;

    width: 100%;
    height: 60px;
    border: 2px solid ${({ isSelected }) => isSelected ? "var(--fixit)" : "var(--light-gray)"};
    border-radius: 40px;
    
    background-color: ${({ isSelected }) => isSelected ? "var(--fixit)" : "var(--white)"};

    cursor: pointer;
    transition: all 0.2s ease-in-out, transform 0.2s ease-in-out;

    &:hover {
        border-color: var(--fixit);
        background-color: ${({ isSelected }) => isSelected ? "var(--fixit)" : "rgba(152, 53, 209, 0.05)"};
        transform: translateY(-3px);
        box-shadow: 0px 4px 12px rgba(152, 53, 209, 0.15);
        
        ${FixcoinValue} {
            color: ${({ isSelected }) => isSelected ? "var(--white)" : "var(--fixit)"};
        }
        
        svg {
            color: ${({ isSelected }) => isSelected ? "var(--white)" : "var(--fixit)"} !important;
        }
    }
`

export const PopularBadge = styled.div`
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #F5A623;
    color: white;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    z-index: 2;
    box-shadow: 0px 2px 4px rgba(245, 166, 35, 0.3);
    
    svg {
        font-size: 10px;
        color: white !important;
    }

    @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
        font-size: 9px;
        padding: 2px 6px;
    }
`

